import { render, staticRenderFns } from "./TweetToInstagram.vue?vue&type=template&id=9dd39872&scoped=true&"
import script from "./TweetToInstagram.vue?vue&type=script&lang=js&"
export * from "./TweetToInstagram.vue?vue&type=script&lang=js&"
import style0 from "./TweetToInstagram.vue?vue&type=style&index=0&id=9dd39872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd39872",
  null
  
)

export default component.exports